'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PricingPlans = exports.Thanks = exports.PartnerRegistration = exports.IsDevelop = exports.VoucherMobile = exports.PromotionDetail = exports.GeneralCampaignListPromotion = exports.Promotion = exports.Survey = exports.NewPassword = exports.ResetPassword = exports.Register = exports.Policy = exports.NotFound = exports.CollectionList = exports.LoginSuccess = exports.Login = exports.HomeService = exports.Home = exports.ForgotPassword = exports.Discover = exports.ServiceDetailDesktop = exports.Detail = exports.CollectionDetail = exports.Chat = exports.Category = exports.AppMobile = exports.AppDesktop = exports.ActiveAccount = exports.Account = exports.About = undefined;

var _About2 = require('./About/About');

var _About3 = _interopRequireDefault(_About2);

var _Account2 = require('./Account/Account');

var _Account3 = _interopRequireDefault(_Account2);

var _ActiveAccount2 = require('./Register/ActiveAccount');

var _ActiveAccount3 = _interopRequireDefault(_ActiveAccount2);

var _AppDesktop2 = require('./App/AppDesktop');

var _AppDesktop3 = _interopRequireDefault(_AppDesktop2);

var _AppMobile2 = require('./App/AppMobile');

var _AppMobile3 = _interopRequireDefault(_AppMobile2);

var _Category2 = require('./Discover/Category');

var _Category3 = _interopRequireDefault(_Category2);

var _Chat2 = require('./Chat/Chat');

var _Chat3 = _interopRequireDefault(_Chat2);

var _CollectionDetail2 = require('./Collection/CollectionDetail');

var _CollectionDetail3 = _interopRequireDefault(_CollectionDetail2);

var _Detail2 = require('./Detail/Detail');

var _Detail3 = _interopRequireDefault(_Detail2);

var _ServiceDetailDesktop2 = require('./Detail/ServiceDetailDesktop');

var _ServiceDetailDesktop3 = _interopRequireDefault(_ServiceDetailDesktop2);

var _Discover2 = require('./Discover/Discover');

var _Discover3 = _interopRequireDefault(_Discover2);

var _ForgotPassword2 = require('./Login/ForgotPassword');

var _ForgotPassword3 = _interopRequireDefault(_ForgotPassword2);

var _Home2 = require('./Home/Home');

var _Home3 = _interopRequireDefault(_Home2);

var _HomeService2 = require('./HomeService/HomeService');

var _HomeService3 = _interopRequireDefault(_HomeService2);

var _Login2 = require('./Login/Login');

var _Login3 = _interopRequireDefault(_Login2);

var _LoginSuccess2 = require('./LoginSuccess/LoginSuccess');

var _LoginSuccess3 = _interopRequireDefault(_LoginSuccess2);

var _CollectionList2 = require('./Collection/CollectionList');

var _CollectionList3 = _interopRequireDefault(_CollectionList2);

var _NotFound2 = require('./NotFound/NotFound');

var _NotFound3 = _interopRequireDefault(_NotFound2);

var _Policy2 = require('./Policy/Policy');

var _Policy3 = _interopRequireDefault(_Policy2);

var _Register2 = require('./Register/Register');

var _Register3 = _interopRequireDefault(_Register2);

var _ResetPassword2 = require('./Register/ResetPassword');

var _ResetPassword3 = _interopRequireDefault(_ResetPassword2);

var _NewPassword2 = require('./Register/NewPassword');

var _NewPassword3 = _interopRequireDefault(_NewPassword2);

var _Survey2 = require('./Survey/Survey');

var _Survey3 = _interopRequireDefault(_Survey2);

var _Promotion2 = require('./Promotion');

var _Promotion3 = _interopRequireDefault(_Promotion2);

var _GeneralCampaignListPromotion2 = require('./Promotion/GeneralCampaignListPromotion');

var _GeneralCampaignListPromotion3 = _interopRequireDefault(_GeneralCampaignListPromotion2);

var _PromotionDetail2 = require('./Promotion/PromotionDetail');

var _PromotionDetail3 = _interopRequireDefault(_PromotionDetail2);

var _VoucherMobile2 = require('./Mobile/Voucher/VoucherMobile');

var _VoucherMobile3 = _interopRequireDefault(_VoucherMobile2);

var _IsDevelop2 = require('./IsDevelop');

var _IsDevelop3 = _interopRequireDefault(_IsDevelop2);

var _PartnerRegistration2 = require('./PartnerRegistration/PartnerRegistration');

var _PartnerRegistration3 = _interopRequireDefault(_PartnerRegistration2);

var _Thanks2 = require('./PartnerRegistration/Thanks');

var _Thanks3 = _interopRequireDefault(_Thanks2);

var _PricingPlans2 = require('./PricingPlans/');

var _PricingPlans3 = _interopRequireDefault(_PricingPlans2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.About = _About3.default;
exports.Account = _Account3.default;
exports.ActiveAccount = _ActiveAccount3.default;
exports.AppDesktop = _AppDesktop3.default;
exports.AppMobile = _AppMobile3.default;
exports.Category = _Category3.default;
exports.Chat = _Chat3.default;
exports.CollectionDetail = _CollectionDetail3.default;
exports.Detail = _Detail3.default;
exports.ServiceDetailDesktop = _ServiceDetailDesktop3.default;
exports.Discover = _Discover3.default;
exports.ForgotPassword = _ForgotPassword3.default;
exports.Home = _Home3.default;
exports.HomeService = _HomeService3.default;
exports.Login = _Login3.default;
exports.LoginSuccess = _LoginSuccess3.default;
exports.CollectionList = _CollectionList3.default;
exports.NotFound = _NotFound3.default;
exports.Policy = _Policy3.default;
exports.Register = _Register3.default;
exports.ResetPassword = _ResetPassword3.default;
exports.NewPassword = _NewPassword3.default;
exports.Survey = _Survey3.default;
exports.Promotion = _Promotion3.default;
exports.GeneralCampaignListPromotion = _GeneralCampaignListPromotion3.default;
exports.PromotionDetail = _PromotionDetail3.default;
exports.VoucherMobile = _VoucherMobile3.default;
exports.IsDevelop = _IsDevelop3.default;
exports.PartnerRegistration = _PartnerRegistration3.default;
exports.Thanks = _Thanks3.default;
exports.PricingPlans = _PricingPlans3.default;

// export Pagination from './Pagination/Pagination';


//////////////////
// WEBPACK FOOTER
// ./src/containers/index.js
// module id = 1695
// module chunks = 0